<template>
  <div class="row ma-0">
    <p class="mr-10">{{ getTitle(cell) }}</p>
    <p>{{ getValueFromReferenceKey(cell.referenceKey) }}</p>
  </div>
</template>

<script>
import { getTitle } from './wb-common';
import { findParentKlassifizierung } from './wb-common';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data: () => ({ getTitle }),
  computed: {
    input() {
      return this.$store.state[this.namespace].formInput;
    },
    klassifizierungen() {
      return this.$store.state[this.namespace].klassifizierungen;
    },
    klassifizierung() {
      //Gets called by WBReferenceCell
      if (this.input.klassifizierung !== undefined) {
        return findParentKlassifizierung(this.input.klassifizierung, this.klassifizierungen, '');
      }
      return this.$t('not_set');
    },
  },
  methods: {
    getValueFromReferenceKey(referenceKey) {
      if (referenceKey === 'klassifizierung') {
        //Needs special treatment
        return this.klassifizierung;
      }
      return this.input[referenceKey];
    },
  },
};
</script>
